/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ClassProvider, NgModule } from '@angular/core';
import { HttpErrorInterceptor } from './http-error.interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders: ClassProvider[] = [
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }
];

@NgModule({
    providers: httpInterceptorProviders
})
export class HttpInterceptorsModule {}
